'use strict';

const {
    WarehouseProduct,
    WarehouseLevel,
    ProductUnit
} = require('../../../../../custom_components/js/warehouse/client/WarehouseLevel')
const {AddProductToLevelRequest} = require("./AddProductToLevelRequest");
const {ClientWarehouseInsertDialogData} = require("../../../../dialogs/warehouse/client/ClientWarehouseInsertDialogData");

module.exports = (app) => app.directive('warehouseLevel', /* @ngInject */ () => {
    return {
        restrict: 'E',
        scope: {
            level: '=',
            remainingQuantity: '=',
            onStockSave: '=',
            productData: '='
        },
        templateUrl: `./${BUILD_PATH}/warehouse-level.directive.html`,
        controller: /* @ngInject */ function ($scope, clientWarehouseService, unitService) {
            $scope.expanded = false;

            /**
             * @type {WarehouseProduct}
             */
            $scope.product = undefined;

            $scope.orderUnit;
            $scope.contentUnit;

            $scope.formData = {
                insertQuantity: 0,
                maxStockNew: 0,
                bookingNote: ''
            };

            $scope.addQuantity = addQuantity;
            $scope.subtractQuantity = subtractQuantity;
            $scope.checkQuantity = checkQuantity;
            $scope.getMaxStorageQuantity = getMaxStorageQuantity;
            $scope.syncMaxStock = syncMaxStock;
            $scope.saveNew = saveNew;
            $scope.insertIntoExisting = insertIntoExisting;
            $scope.setToMaxQuantity = setToMaxQuantity;

            init($scope.level);

            /**
             * @param level {WarehouseLevel}
             */
            function init(level) {
                if (level.storage?.product) {
                    $scope.product = level.storage.product;
                    checkQuantity();
                    unitService.getByUnece(level.storage.units.orderUnit).then(unit => $scope.orderUnit = unit);
                    unitService.getByUnece(level.storage.units.contentUnit).then(unit => $scope.contentUnit = unit);
                }
            }

            function addQuantity() {
                const maxStorageQuantity = getMaxStorageQuantity();
                let newQuantity;
                if (
                    ($scope.formData.insertQuantity + 1) <= maxStorageQuantity &&
                    $scope.remainingQuantity - $scope.formData.insertQuantity >= 1
                ) {
                    newQuantity = $scope.formData.insertQuantity + 1;
                } else {
                    newQuantity = maxStorageQuantity
                }

                $scope.formData.insertQuantity = newQuantity;
            }

            function subtractQuantity() {
                let newQuantity;
                if ($scope.formData.insertQuantity - 1 >= 0) {
                    newQuantity = $scope.formData.insertQuantity - 1;
                } else {
                    newQuantity = $scope.formData.insertQuantity;
                }

                $scope.formData.insertQuantity = newQuantity;
            }

            function checkQuantity() {
                const maxStorageQuantity = getMaxStorageQuantity();
                let newQuantity = $scope.formData.insertQuantity;
                if (newQuantity < 0) {
                    newQuantity = 0;
                }
                if (newQuantity > maxStorageQuantity) {
                    newQuantity = maxStorageQuantity;
                }
                if (newQuantity > $scope.remainingQuantity) {
                    newQuantity = $scope.remainingQuantity;
                }

                $scope.formData.insertQuantity = newQuantity;
            }

            function getMaxStorageQuantity() {
                if ($scope.level.storage) {
                    const maxStock = $scope.level.storage.maxStock - $scope.level.storage.stocked;
                    return $scope.remainingQuantity < maxStock || maxStock <= 0 ? $scope.remainingQuantity : maxStock;
                } else {
                    return $scope.remainingQuantity < $scope.formData.maxStockNew || $scope.formData.maxStockNew <= 0 ? $scope.remainingQuantity : $scope.formData.maxStockNew;
                }
            }

            function setToMaxQuantity() {
                let newInsertQuantity = getMaxStorageQuantity();
                if(newInsertQuantity > $scope.remainingQuantity) {
                    newInsertQuantity = $scope.remainingQuantity;
                }

                $scope.formData.insertQuantity = newInsertQuantity;
            }

            function syncMaxStock() {
                const maxQuantity = getMaxStorageQuantity();
                if($scope.formData.insertQuantity > maxQuantity) {
                    setToMaxQuantity($scope.insertQuantity, maxQuantity)
                }

                return $scope.formData.insertQuantity;
            }

            /**
             *
             * @param newMaxStock {number}
             * @param newQuantity {number}
             * @param level {WarehouseLevel}
             * @param productData {ClientWarehouseInsertDialogData}
             */
            function saveNew(newMaxStock, newQuantity, level, productData) {
                const data = new AddProductToLevelRequest(
                    level.id,
                    productData.productName,
                    productData.productDescription,
                    productData.supplierId,
                    productData.supplierArticleNumber,
                    new ProductUnit({
                        orderUnit: productData.orderUnit,
                        contentUnit: productData.contentUnit,
                        contentUnitsPerOrderUnit: productData.contentUnitsPerOrderUnit
                    }),
                    newQuantity,
                    0,
                    newMaxStock,
                    productData.manufacturerName,
                    productData.manufacturerArticleNumber,
                    productData.articleNumberCustomer,
                    productData.orderItemId
                );

                clientWarehouseService.addProductToLevel(data).then(async () => {
                    updateStockOnReceiptItem(newQuantity).then(() => $scope.onStockSave(newQuantity))
                })
            }

            /**
             * @param quantityToStock {number}
             * @param level {WarehouseLevel}
             * @param productData {ClientWarehouseInsertDialogData}
             */
            function insertIntoExisting(quantityToStock, level, productData) {
                const remainingSpace = level.storage.maxStock > 0 ? level.storage.maxStock - level.storage.stocked : 0;
                if (remainingSpace > 0 && quantityToStock > remainingSpace) {
                    $scope.formData.insertQuantity = remainingSpace;
                    return;
                }

                clientWarehouseService.stockToExistingStorage(level.id, quantityToStock, level.storage.units, productData.orderItemId, $scope.formData.bookingNote).then(() => {
                    updateStockOnReceiptItem(quantityToStock).then(() => $scope.onStockSave(quantityToStock))
                }).catch(() => {
                    $scope.formData.insertQuantity = 0;
                    $scope.$apply();
                })
            }

            function updateStockOnReceiptItem(stockedQuantity) {
                if($scope.productData.receiptId && $scope.productData.receiptItemId) {
                    return clientWarehouseService.stockReceiptItem($scope.productData.receiptId, $scope.productData.receiptItemId, stockedQuantity);
                }

                return Promise.resolve();
            }
        }
    };
})
